<template>
  <el-dialog class="dialog-create-plan" :title="pageType==='add' ?'发布通知公告':'编辑通知公告'" :visible.sync="dialogVisible" :before-close="handleBeforeClose" width="850px">
    <div class="wrap">
      <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="通知公告标题 :" prop="name">
          <el-input v-model="form.name" placeholder="请输入" :disabled="pageType==='detail'"></el-input>

        </el-form-item>

        <el-form-item label="接受人群:" prop="rang">
          <el-radio-group v-model="form.rang">
            <el-radio v-for="(item, index) in typeList" :label="item.dictCode" :key="index">{{item.dictName}}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="内容 :" prop="content">
          <cmp-ckeditor ref="myCkeditor" :defaultMsg="form.content" :id="`ue1`" :height="500"></cmp-ckeditor>
        </el-form-item>

        <el-form-item label="附件 :">
          <!-- 上传 -->
          <!-- :fileList="form.attachmentList" -->
          <cmpUploadProgress ref="cmpUploadProgress" :fileList="form.attachmentList" :callFun="uploadCallback" :showUpload="pageType==='detail' || pageType==='approval' ? false : true" :showTip="pageType==='detail' || pageType==='approval'?false:true" :accept="`.rar, .zip, .doc, .docx, .pdf, .jpg`"></cmpUploadProgress>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="footer mt-30" v-if="pageType!=='detail'">
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">{{pageType == 'add' ? '发布' : '修改'}}</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import cmpUploadProgress from '@cmp/my-upload/upload-progress' // 上传组件
import cmpCkeditor from '@cmp/editor/ckeditor'
export default {
  components: {
    cmpUploadProgress,
    cmpCkeditor
  },

  data() {
    return {
      loadingSave: false,
      pageType: 'add', // 页面类型 add 新增  edit 编辑  detail 详情
      detailId: '', // 用户id
      form: {},
      typeList: [{
        dictCode: '0',
        dictName: '全部'
      }, {
        dictCode: '1',
        dictName: '正式志愿者'
      }, {
        dictCode: '2',
        dictName: '预备志愿者'
      }, {
        dictCode: '3',
        dictName: '学生志愿者'
      }, {
        dictCode: '4',
        dictName: '小志愿者'
      }],
      dialogVisible: false,
      rules: {
        rang: [
          { required: true, message: '必填', trigger: 'blur' },
          // { min: 1, max: 30, message: '请输入1到30个字符', trigger: 'blur' }
        ],
        name: [{ required: true, message: '必填', trigger: 'blur' }],
      },
    }
  },

  methods: {
    init(type, id) {
      this.dialogVisible = true
      // 清空弹框数据
      this.form = { attachmentList: [] }
      this.pageType = type // 页面类型
      this.detailId = id || '' // 详情id
      // 新增或编辑
      if (this.detailId) {
        this.getDetailData()
      }
      // this.getDropdownValue()
      this.$nextTick(() => {
        this.$refs.cmpUploadProgress.init() // 触发子组件上传组件方法
        this.$refs.myCkeditor.initEditor()
        this.$refs['form'].clearValidate() // 清空验证状态
      })
    },

    // 获取详情
    getDetailData() {
      this.$api.volunteer.getNoticeDetail({ id: this.detailId }).then(res => {
        if (res.success) {
          let results = res.result
          this.form = results
          this.form.rang = JSON.stringify(results.rang)
          // this.form.attachmentList = res.result.fileList
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 获取下拉状态选择值
    getDropdownValue() {
      this.$http
        .get('/collectDict/getSelectDataByKey', { key: 'volunteer_identity_type' })
        .then(res => {
          if (res.success) {
            this.typeList = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 文件上传回调
    uploadCallback(fileStr) {
      this.form.attId = fileStr
    },

    // 保存
    fromSubmit(form) {
      let content = this.$refs.myCkeditor.getContent(), url = "" // 调用子组件方法
      if (!content) {
        this.$message.warning('请输入内容')
        return
      }
      this.$refs[form].validate(vaild => {
        if (vaild) {
          if (this.pageType === 'edit') {
            url = 'editNotice'
            this.form.id = this.detailId
          } else {
            url = 'addNotice'
          }
          this.loadingSave = true
          this.$api.volunteer[url]({
            id: this.form.id ? this.form.id : '',
            name: this.form.name,
            attId: this.form.attId,
            rang: this.form.rang,
            content: content,
            attachmentList: this.form.attachmentList
          }).then(res => {
            this.loadingSave = false
            if (res.success) {
              if (this.pageType === 'edit') {
                this.$message.success('通知公告编辑成功')
              } else if (this.pageType === 'add') {
                this.$message.success('通知公告创建成功')
              }
              this.dialogVisible = false
              this.$emit('refresh')
            } else {
              this.$message.error(res.message)
            }
          })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },

    // 取消
    cancel() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },

    handleBeforeClose(done) {
      this.$refs['form'].resetFields()
      this.$refs.myCkeditor.setContent('')  // 处理编辑时偶尔不能渲染出富文本数据
      done()
    }
  }
}
</script>

<style>
</style>